var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEyeOff = function SvgIconEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.578 8.332a10.415 10.415 0 0 1-1.942 2.42l-.94-.942a8.932 8.932 0 0 0 1.522-1.807c-.622-.946-2.504-3.407-5.364-3.335-.4.01-.776.073-1.133.168L5.668 3.782a6.238 6.238 0 0 1 2.152-.446c3.983-.125 6.333 3.591 6.758 4.332a.669.669 0 0 1 0 .664Zm-5.3 2.832 1.054 1.054a6.234 6.234 0 0 1-2.316.448c-3.908 0-6.175-3.603-6.594-4.334a.666.666 0 0 1 0-.664c.276-.482.926-1.494 1.941-2.42l.94.942a8.955 8.955 0 0 0-1.521 1.807c.621.946 2.494 3.401 5.364 3.335.4-.01.776-.073 1.132-.168ZM8 9a1 1 0 0 1-1-1c0-.017.007-.032.008-.05L8.05 8.992C8.032 8.993 8.017 9 8 9ZM3.138 2.195a.667.667 0 0 0-.943.943L5.95 6.892A2.303 2.303 0 0 0 5.666 8 2.336 2.336 0 0 0 8 10.333c.393 0 .77-.098 1.108-.282l3.754 3.753a.663.663 0 0 0 .942 0 .666.666 0 0 0 0-.942L3.138 2.195Z",
    fill: "#636363",
    fillRule: "nonzero"
  })));
};

export default SvgIconEyeOff;